<template>
	<div class="page-mouth">
		<div class="case">
			<time-num></time-num>
			<div class="icons" @click="handlecaseClick()">
				<img src="./../../assets/treat/case.png" alt />
			</div>
		</div>
		<div class="choose-box">
			<div class="choose-text">
				{{ affirmObj.title }}
				({{ affirmObj.typeName }}):
			</div>
			<div v-for="(item, index) in affirmObj.optionList" :class="item.flag ? 'choose-active' : ''"
				class="choose-list" @click="handleChooseClick(item, index)" :key="index">
				<p>{{ item.value }}</p>
				<div class="text">{{ item.content }}</div>
			</div>
		</div>
		<div class="btn">
			<!-- <div class="nextquestionactive" @click="$router.replace('/treat/affirm')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div> -->
			<div class="return" @click="handleSubmit" :class="isDisabled ? 'pointer' : ''">
				<img src="./../../assets/treat/submit.png" alt />
				<span>提交</span>
			</div>
		</div>
		<div class="page-mouthModal" v-if="visible">
			<div class="content">
				<div class="title">提示！</div>
				<div class="text">
					<p>您尚未选择疗法,</p>
					<p>请再仔细审查题目。</p>
				</div>
				<div class="footer">
					<button @click="handleOk">确定</button>
				</div>
			</div>
		</div>
		<div class="page-mouthModal" v-if="isTimeEnd">
			<div class="content">
				<div class="title">提示！</div>
				<div class="text">
					<p>{{ isTimeMsg }}</p>
				</div>
				<div class="footer">
					<button @click="handleTimeOk">确定</button>
				</div>
			</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		submitPetAnswer
	} from "@/api/system/exam";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				affirmObj: {},
				activeIndex1: null,
				visible: false,
				answerData: [],
				treatmentLists: null,
				isTimeEnd: false,
				isTimeMsg: null,
				isDisabled: false,
			};
		},
		computed: {
			...mapState("visualExamination", [
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentList",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		watch: {},
		created() {
			this.treatmentLists = this.treatmentList;
			this.affirmObj = this.treatmentLists.step6Questions[1];
			this.affirmObj.optionList.map((v) => {
				v.flag = false;
			});
		},
		mounted() {},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),

			//关闭弹框
			handleOk() {
				this.visible = false;
			},

			// 弹出结束弹框
			handleTimeOk() {
				this.isTimeEnd = false;
				this.$router.replace({
					path: "/index/home2026",
					query: {
						isLogin: false
					},
				});
			},

			//选题
			handleChooseClick(item, index) {
				if (this.affirmObj.type === "2" || this.affirmObj.type === "3") {
					this.affirmObj.optionList.map((v) => {
						if (item.id === v.id) {
							v.flag = !v.flag;
						}
					});
				} else {
					this.activeIndex1 = index;
					this.affirmObj.optionList.map((v, i) => {
						if (index === i) {
							v.flag = !v.flag;
						} else {
							v.flag = false;
						}
					});
				}
				this.$forceUpdate();
			},

			//病例记录
			handlecaseClick() {
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: this.treatmentList.id,
					questionId: '-2022',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace({
						path: "/treat/medicalrecord",
						query: {
							num: 6
						},
					});
				});
			},

			//提交
			handleSubmit() {
				let idList = [];
				let list = [];
				this.affirmObj.optionList.forEach((item) => {
					if (item.flag) {
						idList.push(item.value);
					}
				});
				if (this.affirmObj.type === "1") {
					if (idList.length !== 1) {
						this.visible = true;
						return;
					}
				} else {
					if (idList.length <= 1) {
						this.visible = true;
						return;
					}
				}
				const val = idList.join(",");
				list = {
					answers: val,
					questionId: this.affirmObj.id
				};
				this.VISUAL_EXAMINATION({
					key: "detail5",
					value: list
				});
				this.VISUAL_EXAMINATION({
					key: "overIndex",
					value: 6
				});
				// const arr1 = this.detail.concat(this.detail2); //步骤二/三 做完答案
				// const arr2 = arr1.concat(this.detail3); //步骤二/三/四 做完答案
				// const arr3 = [this.detailstepPre3, this.detail4, this.detail5]; //步骤二/三/四/五 做完答案
				// const arr4 = arr3.concat(arr2); //步骤二/三/四/五/六 做完答案
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				this.isDisabled = true;
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitPetAnswer(parmes).then((res) => {
					this.isDisabled = false;
					if (res.data.code === 0) {
						submitExamCommitSingerAnswer({
							backendAnswers: JSON.stringify(parmes),
							paperId: this.treatmentList.id,
							questionId: '-11',
							answers: JSON.stringify({
								detail: this.detail,
								detailsz2: this.detailsz2,
								detail3: this.detail3,
								detailstepPre3: this.detailstepPre3,
								detail4: this.detail4,
								detail5: this.detail5,
								treatmentEcho: this.treatmentEcho
							}),
							extractDetailId: this.examDetailId,
						}).then((response) => {
							this.VISUAL_EXAMINATION({
								key: "treatModleTime",
								value: false
							});
							this.answerData = res.data.data;
							this.$router.replace({
								// path: "/treat/examineResult",
								// 第二个版本
								path: "/treat/assemble",
							});
						});

					} else {
						this.isTimeEnd = true;
						this.isTimeMsg = res.data.msg;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.page-mouth {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 45px;

		.case {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding: 24px 33px 24px 0;
			position: relative;

			.time-num {
				width: 88%;
				padding: 10px 0;
			}

			.icons {
				width: 93px;
				position: absolute;
				right: 0;
			}

			img {
				width: 93px;
				height: 93px;
			}
		}

		.case-png {
			z-index: 99;

			img {
				transform: scale(1.3);
			}
		}

		.choose-box {
			margin-top: 5px;
			width: 100%;
			height: auto;
			background: rgba(255, 255, 255, 0.5);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 40px 45px 40px 45px;

			.choose-text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 50px;
			}

			.choose-list {
				width: 100%;
				height: auto;
				background: #ffffff;
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				border-radius: 40px;
				margin-top: 20px;
				font-size: 25px;
				font-family: HarmonyOS Sans SC;
				font-weight: 400;
				color: #4d4d4d;
				display: flex;
				align-items: center;
				padding: 28px 61px;

				p {
					position: relative;
					margin-right: 19px;
				}

				p::before {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 39px;
					content: "";
					width: 2px;
					height: 38px;
					background: #cccccc;
				}

				div {
					margin-left: 35px;
				}
			}

			.choose-active {
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				background: #ab3b91;
				color: #fff;
			}

			.choose-active>p::before {
				background: #fff;
			}
		}

		.btn {
			width: 100%;
			height: 183px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			border-radius: 60px 60px 0px 0px;
			position: absolute;
			left: 0;
			bottom: 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;

			.return {
				width: 426px;
				height: 87px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				display: flex;
				border-radius: 60px;
				align-items: center;
				justify-content: center;

				img {
					width: 36px;
					height: 33px;
					margin-right: 17px;
				}

				span {
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 59px;
				}
			}

			.pointer {
				pointer-events: none;
			}
		}

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			padding: 0 40px;
			display: flex;
			align-items: center;
			z-index: 1;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding-top: 90px;
				padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footer {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>